import {
    REQUEST_DEVICE_LOG_OPEN_MODAL,
    REQUEST_DEVICE_LOG_CLOSE_MODAL,
    REQUEST_DEVICE_LOG_REQUEST,
    REQUEST_DEVICE_LOG_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case REQUEST_DEVICE_LOG_OPEN_MODAL:
            return { ...state, openModal: true }

        case REQUEST_DEVICE_LOG_CLOSE_MODAL:
            return { ...state, openModal: false }

        case REQUEST_DEVICE_LOG_REQUEST:
            return { ...state, loading: true }

        case REQUEST_DEVICE_LOG_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "REQUEST_DEVICE_LOG"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
                
        default:
            return state;
    }
};